import React from 'react';
import { t } from 'Src/i18n';
import { Title } from 'Components/frameworks/title/Title';
import { GreatMembersPointsSimulator } from 'Components/widgets/great-members-points-simulator/GreatMembersPointsSimulator';
type Props = {
  className?: string;
  loyaltyProgramSimulation: LoyaltyProgramSimulation;
};
export const GreatMembersSimulator = ({ className, loyaltyProgramSimulation }: Props) => {
  const loyaltyProgramCurrency = loyaltyProgramSimulation.currency;
  return (
    <div className={className}>
      <Title hLevel={2} theme="title-brand-n2">
        {t('customerAccount.greatMember.pointsSection.simulator.title')}
      </Title>
      <Title className="text-sienna" hLevel={3} theme="title-sans-n2">
        {t('customerAccount.greatMember.pointsSection.simulator.subtitle')}
      </Title>
      <GreatMembersPointsSimulator
        className="mt-20"
        currencyCode={loyaltyProgramCurrency}
        id="simulator"
      />
    </div>
  );
};
